import { render } from "./BrandSideMenuItem.vue?vue&type=template&id=ba5acdc4"
import script from "./BrandSideMenuItem.vue?vue&type=script&lang=js"
export * from "./BrandSideMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__